import { render } from "./Banks.vue?vue&type=template&id=4fd7cf51&scoped=true"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"

import "./Banks.vue?vue&type=style&index=0&id=4fd7cf51&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd7cf51"]])

export default __exports__